export enum CaseTypeCategory {
    CIVIL = 'CIVIL',
    CRIMINAL = 'CRIMINAL',
    INSOLVENCY = 'INSOLVENCY',
    CORPORATE = 'CORPORATE',
    TAX = 'TAX',
    COMMERCIAL = 'COMMERCIAL',
    CONSTITUTIONAL = 'CONSTITUTIONAL',
    ARBITRATION = 'ARBITRATION',
    CONSUMER = 'CONSUMER',
    LABOUR = 'LABOUR',
    MOTOR_ACCIDENT = 'MOTOR_ACCIDENT',
    RECOVERY_DEBT = 'RECOVERY_DEBT',
    REGULATORY = 'REGULATORY',
    OTHER = 'OTHER',
}

export const CASE_TYPE_LABEL: Record<CaseTypeCategory, string> = {
    [CaseTypeCategory.CIVIL]: 'Civil',
    [CaseTypeCategory.CRIMINAL]: 'Criminal',
    [CaseTypeCategory.INSOLVENCY]: 'Insolvency',
    [CaseTypeCategory.CORPORATE]: 'Corporate',
    [CaseTypeCategory.TAX]: 'Tax',
    [CaseTypeCategory.COMMERCIAL]: 'Commercial',
    [CaseTypeCategory.CONSTITUTIONAL]: 'Constitutional',
    [CaseTypeCategory.ARBITRATION]: 'Arbitration',
    [CaseTypeCategory.CONSUMER]: 'Consumer',
    [CaseTypeCategory.LABOUR]: 'Labour',
    [CaseTypeCategory.MOTOR_ACCIDENT]: 'Motor Accident',
    [CaseTypeCategory.RECOVERY_DEBT]: 'Recovery / Debt',
    [CaseTypeCategory.REGULATORY]: 'Regulatory',
    [CaseTypeCategory.OTHER]: 'Other',
};

export const CASE_TYPE_COLOR: Record<CaseTypeCategory, string> = {
    [CaseTypeCategory.CIVIL]: '#F5C842',
    [CaseTypeCategory.CRIMINAL]: '#F26B1F',
    [CaseTypeCategory.INSOLVENCY]: '#8E2420',
    [CaseTypeCategory.CORPORATE]: '#E8A62E',
    [CaseTypeCategory.TAX]: '#F0852B',
    [CaseTypeCategory.COMMERCIAL]: '#E4551F',
    [CaseTypeCategory.CONSTITUTIONAL]: '#F4B93D',
    [CaseTypeCategory.ARBITRATION]: '#B32B1E',
    [CaseTypeCategory.CONSUMER]: '#F7DA6A',
    [CaseTypeCategory.LABOUR]: '#9C5A24',
    [CaseTypeCategory.MOTOR_ACCIDENT]: '#D93A29',
    [CaseTypeCategory.RECOVERY_DEBT]: '#C56A22',
    [CaseTypeCategory.REGULATORY]: '#CE8A2A',
    [CaseTypeCategory.OTHER]: '#D8C29A',
};

export const DISPOSED_COLOR = '#D6E4F5';

export const DEFAULT_BAR_PALETTE = ['#DF666A', '#F6C250', '#FF7A0E'];
